import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const settingApi = {
  getSettings: async () => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.SETTINGS}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  },

  updateSettings: async (formData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.SETTINGS}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  },

  sendTestEmail: async () => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.SETTINGS}/send-test-email`);
      return response.data;
    } catch (error) {
      console.error('Error sending test email:', error);
      throw error;
    }
  },

  clearCache: async () => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.SETTINGS}/clear-cache`);
      return response.data;
    } catch (error) {
      console.error('Error clearing cache:', error);
      throw error;
    }
  },


  generateSitemap: async () => { // New function for sitemap generation
    try {
      const response = await apiClient.post(API_ENDPOINTS.GENERATE_SITEMAP);
      return response.data;
    } catch (error) {
      console.error('Error generating sitemap:', error);
      throw error;
    }
  },
};

export default settingApi;